module.exports = function getResource(label, vars = []) {
    let resources = {
        emailAndMailPreferences: 'Courriel et préférences'
    };
    return resources[label];
};
